var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWave2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3050,
    height: 59,
    viewBox: "0 0 3050 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3605",
    "data-name": "Group 3605",
    transform: "translate(-435 -1339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WAVES_02",
    "data-name": "WAVES 02",
    transform: "translate(435 1339)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8775",
    "data-name": "Path 8775",
    d: "M836.6,431.234c-17.463,15.271-39.516,24.387-63.493,24.387s-46.028-9.116-63.492-24.387c-17.463,15.271-39.517,24.387-63.493,24.387s-46.029-9.116-63.493-24.387c-17.463,15.271-39.516,24.387-63.492,24.387s-46.03-9.116-63.493-24.387c-17.463,15.271-39.516,24.387-63.493,24.387s-46.029-9.116-63.492-24.387c-17.463,15.271-39.517,24.387-63.493,24.387s-46.028-9.116-63.493-24.387c-17.463,15.271-39.516,24.387-63.492,24.387A97.567,97.567,0,0,1,74.1,431.234c-.68,14.932,0,54.055,0,54.055H836.6S841.742,472.172,836.6,431.234Z",
    transform: "translate(-74.101 -426.289)",
    fill: "#309ea7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8776",
    "data-name": "Path 8776",
    d: "M836.6,431.234c-17.463,15.271-39.516,24.387-63.493,24.387s-46.028-9.116-63.492-24.387c-17.463,15.271-39.517,24.387-63.493,24.387s-46.029-9.116-63.493-24.387c-17.463,15.271-39.516,24.387-63.492,24.387s-46.03-9.116-63.493-24.387c-17.463,15.271-39.516,24.387-63.493,24.387s-46.029-9.116-63.492-24.387c-17.463,15.271-39.517,24.387-63.493,24.387s-46.028-9.116-63.493-24.387c-17.463,15.271-39.516,24.387-63.492,24.387A97.567,97.567,0,0,1,74.1,431.234c-.68,14.932,0,54.055,0,54.055H836.6S841.742,472.172,836.6,431.234Z",
    transform: "translate(688.399 -426.289)",
    fill: "#309ea7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "WAVES_02-2",
    "data-name": "WAVES 02",
    transform: "translate(1960 1339)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8910",
    "data-name": "Path 8910",
    d: "M836.6,431.234c-17.463,15.271-39.516,24.387-63.493,24.387s-46.028-9.116-63.492-24.387c-17.463,15.271-39.517,24.387-63.493,24.387s-46.029-9.116-63.493-24.387c-17.463,15.271-39.516,24.387-63.492,24.387s-46.03-9.116-63.493-24.387c-17.463,15.271-39.516,24.387-63.493,24.387s-46.029-9.116-63.492-24.387c-17.463,15.271-39.517,24.387-63.493,24.387s-46.028-9.116-63.493-24.387c-17.463,15.271-39.516,24.387-63.492,24.387A97.567,97.567,0,0,1,74.1,431.234c-.68,14.932,0,54.055,0,54.055H836.6S841.742,472.172,836.6,431.234Z",
    transform: "translate(-74.101 -426.289)",
    fill: "#309ea7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8911",
    "data-name": "Path 8911",
    d: "M836.6,431.234c-17.463,15.271-39.516,24.387-63.493,24.387s-46.028-9.116-63.492-24.387c-17.463,15.271-39.517,24.387-63.493,24.387s-46.029-9.116-63.493-24.387c-17.463,15.271-39.516,24.387-63.492,24.387s-46.03-9.116-63.493-24.387c-17.463,15.271-39.516,24.387-63.493,24.387s-46.029-9.116-63.492-24.387c-17.463,15.271-39.517,24.387-63.493,24.387s-46.028-9.116-63.493-24.387c-17.463,15.271-39.516,24.387-63.492,24.387A97.567,97.567,0,0,1,74.1,431.234c-.68,14.932,0,54.055,0,54.055H836.6S841.742,472.172,836.6,431.234Z",
    transform: "translate(688.399 -426.289)",
    fill: "#309ea7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave2);
export default __webpack_public_path__ + "static/media/wave2.591d204a.svg";
export { ForwardRef as ReactComponent };